import { Notice, Text, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, memo } from "react";
import MemoChartPlaceholder from "../../../svg/ChartPlaceholder";

interface ITasteTestEmptyChartViewProps {
  title: string;
  description: string;
}

const TasteTestEmptyChartView: FC<ITasteTestEmptyChartViewProps> = ({ title, description }) => {
  return (
    <div
      className="relative flex w-full flex-col gap-4"
      style={{
        WebkitMaskImage:
          "linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 60%, transparent 100%)",
      }}
    >
      <MemoChartPlaceholder className="h-60 w-full opacity-75" />
      <Notice
        className={cx("absolute z-10", toolkitCx.recipes.center.both())}
        type="warning"
        size="sm"
        title={title}
      >
        <Text tag="span" size="xs" variant="current">
          {description}
        </Text>
      </Notice>
    </div>
  );
};

export default memo(TasteTestEmptyChartView);
